export default {"src":"/_next/static/media/back_arrow.2ca79d86.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};